import React, { useState } from 'react';
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import voyaLogo from '../assets/img/brand/voya-logo.svg';
import UserDropdown from './UserDropdown';

export const NavMenu = (props) => {
  const [collapsedNav, setCollapsedNav] = useState(true);
  const [collapsedUser, setCollapsedUser] = useState(true);

  const toggleNavbar = () => {
    setCollapsedNav(!collapsedNav);
  }

  const toggleUserDropDown = () => {
    setCollapsedUser(!collapsedUser);
  }

  return (
    <>
      <header className="fixed-menu" id="nprogress-load-section">
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow nav-dark" id="main-nav" light>
          <Container className="career-nav-container">
            <NavbarBrand tag={Link} to="/" className="custom-link">
              <img src={voyaLogo} alt="Voya logo" className="iqor-logo" />
            </NavbarBrand>
            <NavbarToggler onClick={toggleNavbar} className="mr-2" />
            <Collapse className="career-nav-collapse d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsedNav} navbar>
              <ul className="navbar-nav flex-grow">
                {
                  (props.jobsUrl !== "") ?
                    (
                      <>
                        <NavItem>
                          <a className="text-dark nav-link" href={props.jobsUrl}>Home</a>
                        </NavItem>

                        <NavItem>
                          <a className="text-dark nav-link" href={props.jobsUrl + "/jobs"}>View All Jobs</a>
                        </NavItem>
                      </>
                    ) :
                    (
                      <>
                        <NavItem>
                          <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                        </NavItem>

                        {/**< NavItem >
                          <NavLink tag={Link} className="text-dark" to="/jobs">View All Jobs</NavLink>
                        </NavItem>**/}
                      </>
                    )
                }

                <UserDropdown collapsedUser={collapsedUser} toggleUserDropDown={toggleUserDropDown} />
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
}
